"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("@eduact/utils");
var _edSystem = require("@eduact/ed-system");
var _react = _interopRequireWildcard(require("react"));
var _Modal = require("./Modal.styled");
var _excluded = ["children", "open", "onClose", "withBackdrop", "withStyling", "withDelay", "persistent", "center", "scrollableBackground"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Modal = function Modal(_ref) {
  var children = _ref.children,
    open = _ref.open,
    onClose = _ref.onClose,
    _ref$withBackdrop = _ref.withBackdrop,
    withBackdrop = _ref$withBackdrop === void 0 ? true : _ref$withBackdrop,
    _ref$withStyling = _ref.withStyling,
    withStyling = _ref$withStyling === void 0 ? false : _ref$withStyling,
    _ref$withDelay = _ref.withDelay,
    withDelay = _ref$withDelay === void 0 ? true : _ref$withDelay,
    _ref$persistent = _ref.persistent,
    persistent = _ref$persistent === void 0 ? false : _ref$persistent,
    _ref$center = _ref.center,
    center = _ref$center === void 0 ? false : _ref$center,
    _ref$scrollableBackgr = _ref.scrollableBackground,
    scrollableBackground = _ref$scrollableBackgr === void 0 ? true : _ref$scrollableBackgr,
    props = _objectWithoutProperties(_ref, _excluded);
  var modalRef = (0, _react.useRef)(null);
  var delayed = (0, _utils.useDelayedUnmount)({
    delay: 1000,
    mounted: open
  });
  (0, _utils.useOutsideAlert)(modalRef, function () {
    if (!persistent) {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }
  });
  (0, _react.useEffect)(function () {
    if (scrollableBackground) return;
    if (open || delayed && withDelay) {
      document.documentElement.style.overflowY = 'hidden';
      document.body.style.overflowY = 'hidden';
    } else {
      document.documentElement.style.overflowY = '';
      document.body.style.overflowY = '';
    }
  }, [open, delayed, withDelay]);
  return /*#__PURE__*/_react["default"].createElement(_edSystem.Portal, props, (open || delayed && withDelay) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, withStyling && /*#__PURE__*/_react["default"].createElement(_Modal.Backdrop, _extends({}, props, {
    position: !!props.parent ? 'relative' : 'fixed',
    withBackdrop: withBackdrop,
    open: open && delayed,
    center: center
  }), /*#__PURE__*/_react["default"].createElement("div", {
    ref: modalRef
  }, children)), !withStyling && /*#__PURE__*/_react["default"].createElement(_Modal.UnStyledBackdrop, _extends({}, props, {
    ref: modalRef
  }), children)));
};
var _default = Modal;
exports["default"] = _default;